import { Icon } from '@/components/ui';
import { Checkbox as ChakraCheckbox, CheckboxProps } from '@chakra-ui/react';
import React from 'react';

export const Checkbox: React.FC<CheckboxProps> = (props) => {
  return <ChakraCheckbox icon={<Icon icon={'check2'} />} {...props} />;
};
